import { Play } from 'lucide-react'

const VideoPreview = ({ video, handleVideoClick, calculateSrcSet }) => {
    const formatDuration = (seconds) => {
        const mins = Math.floor(seconds / 60)
        const secs = Math.floor(seconds % 60)
        return `${mins}:${secs.toString().padStart(2, '0')}`
    }

    return (
        <div
            className="position-relative cursor-pointer"
            onClick={() => handleVideoClick(video)}
            style={{ cursor: 'pointer' }}
        >
            <img
                src={video.thumbnails[0].url}
                srcSet={calculateSrcSet(video)}
                alt={video.name}
                style={{
                    width: '100%',
                    height: 'auto',
                    borderRadius: '8px',
                    transition: 'transform 0.2s ease',
                }}
                onMouseEnter={(e) => (e.target.style.transform = 'scale(1.02)')}
                onMouseLeave={(e) => (e.target.style.transform = 'scale(1)')}
            />
            <div
                className="position-absolute top-50 start-50 translate-middle"
                style={{
                    background: 'rgba(0, 0, 0, 0.7)',
                    borderRadius: '50%',
                    width: '36px',
                    height: '36px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <Play size={20} />
            </div>
            {video.duration && (
                <div
                    className="position-absolute bottom-0 end-0 m-2"
                    style={{
                        background: 'rgba(0, 0, 0, 0.8)',
                        color: 'white',
                        padding: '2px 6px',
                        borderRadius: '4px',
                        fontSize: '12px',
                    }}
                >
                    {formatDuration(video.duration)}
                </div>
            )}
        </div>
    )
}

export default VideoPreview
